import { FunnelIcon, UsersIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useQueryClient } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import Tooltip from "react-tooltip";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useEmployeesAsync } from "../hooks/useEmployeesAsync";
import { getEmployeesAsync } from "actions/Employees";
import AddButton from "components/AddButton";
import ConfirmBoxDelete from "components/ConfirmBoxDelete";
import ConfirmBoxOk from "components/ConfirmBoxOk";
import DownloadButton from "components/DownloadButton";
import EditButton from "components/EditButton";
import { toast } from "components/toastNotification";
import { EmployeeTabs } from "../../../../EmployeeTab/EmployeeTab";
import { accountAtom } from "../../../../Login/atoms/AccountAtom";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../../OfficeTab/OfficeTabs";
import { PERMISSIONS } from "../../../../PermissionsConstants";
import { ReportsTabs } from "../../../../ReportsTab/ReportsTab";
import { mainSelectedTab } from "../../../atoms";
import { CarrierAgreementMgmtTabs } from "../../../carrierAgreementTabs";
import {
  officeHierarchyShowState,
  showTable,
} from "../../../OfficeHierarchy/atoms/atoms";
import {
  hideEmpPagerow,
  officeIdValue,
} from "../../../OfficeSettings/atoms/atoms";
import { useSFGetOffice } from "../../../OfficeSettings/hooks/useSFGetOffice";
import {
  empAddState,
  empEditState,
  empFilterValues,
  employeeFromOffice,
  employeeFromReports,
  employeeShowState,
  employeeViewData,
  FromNotifEmp,
  OfficeListFromLink,
  rowForEditEmployees,
  selectedRowsStateEmployee,
  mexicoOnly,
  FranchiseOfficeDetailsData,
  showDataModalState,
  employeeDataState,
} from "../atoms/atoms";
import EmployeeForm from "../forms/EmployeeForm";
import { useDeleteEmployee } from "../hooks/useDeleteEmployee";
import useEmployeeAsyncDownload from "../hooks/useEmployeeAsyncDownload";
import { useEmployeeNumber } from "../hooks/useEmployeeNumber";
import { useEmployeeTitle } from "../hooks/useEmployeeTitle";
import useGetAllEmployees from "../hooks/useGetAllEmployees";
import { useGetReportsToEmployees } from "../hooks/useGetReportsToEmployees";
import useSearchEmployees from "../hooks/useSearchEmployees";
import TableFilters from "../TableFilters";
import EmployeesExpandedRow from "./EmployeesExpandedRow";
import { useEmployeeDepartment } from "../hooks/useEmployeeDepartment";
import MaterialTableEmployees from "components/tables/MaterialTableEmployees";
import { useGetEmployeeAdOverrideGroup } from "../hooks/useGetEmployeeAdOverrideGroup";

const EmployeesTable = ({ data = [], officeCode, viewFromOffice = false }) => {
  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const [isHideEmpPagerow] = useRecoilState(hideEmpPagerow);
  const [showFromOffice, setShowFromOffice] =
    useRecoilState(employeeFromOffice);
  const [, setShowFromReports] = useState(employeeFromReports);
  const [showFromActiveSPLCReports, setShowFromActiveSPLCReports] =
    useState(false);
  const [showFromActiveReports, setShowFromActiveReports] = useState(false);
  const [showFromNoEmailReports, setShowFromNoEmailReports] = useState(false);
  const [showFromClosedLocation, setshowFromClosedLocation] = useState(false);
  const [showOfficeHierarchy, setShowOfficeHierarchy] = useState(false);
  const [showOfficeHierarchySplcOrgChart, setShowOfficeHierarchySplcOrgChart] =
    useState(false);
  const [
    showOfficeHierarchySalesOrgChart,
    setShowOfficeHierarchySalesOrgChart,
  ] = useState(false);
  const [, setShowOfficeHierarchyNsaOrgChart] = useState(false);
  const [showOfficeHierarchyFromView, setShowOfficeHierarchyFromView] =
    useState(false);
  const [showFromEmpOrgChart, setShowFromEmpOrgChart] = useState(false);
  const [showOfficeHier, setShowOfficeHier] = useRecoilState(
    officeHierarchyShowState
  );
  const [showFromHierarchy, setViewFromHierarchy] = useState(false);
  const [showFromHierarchyTable, setShowFromHierarchyTable] = useState(false);
  const [showFromHierarchyOrgChartNsa, setShowFromHierarchyOrgChartNsa] =
    useState(false);
  const [showFromHierarchyOrgChartSplc, setShowFromHierarchyOrgChartSplc] =
    useState(false);
  const [showProducerName, setShowProducerName] = useState(false);
  const setOfficeCodeList = useSetRecoilState(OfficeListFromLink);
  const [showFromReportsWithTerminated, setShowFromReportsWithTerminated] =
    useState(false);
  const [
    showFromReportsEmployeeActiveTempReports,
    setShowFromReportsEmployeeActiveTempReports,
  ] = useState(false);
  const [
    showFromPendingTerminationReports,
    setShowFromPendingTerminationReports,
  ] = useState(false);
  const {
    mutate: deleteEmployeesByNumber,
    isSuccess: deleteSuccess,
    isError: deleteError,
    data: deleteResult,
    reset: deleteReset,
  } = useDeleteEmployee();
  const [isAdd, setAddState] = useRecoilState(empAddState);
  const [isEdit, setEditstate] = useRecoilState(empEditState);
  const [isShow, setShowState] = useRecoilState(employeeShowState);
  const [rowViewData, setRowViewData] = useRecoilState(employeeViewData);
  const setShowFromEmpOfficeDetails = useSetRecoilState(
    FranchiseOfficeDetailsData
  );

  const setRowToEdit = useSetRecoilState(rowForEditEmployees);
  const user = useRecoilValue(accountAtom);

  const { data: employees } = useGetAllEmployees();
  const [employeesOption, setEmployeesOption] = useState([]);
  const [, setSearchedEmployee] = useState([]);
  const [, setReset] = useState(true);
  const [exportdata, setExportdata] = useState([]);
  const [empAsyncData] = useState([]);
  const [selectedRowsToDelete, setSelectedRowsToDelete] = useRecoilState(
    selectedRowsStateEmployee
  );
  const [empList, setEmpList] = useState([]);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const tableRef = useRef(0);
  const csvRef = useRef();
  const userPermissions = useRecoilValue(permissionsSelector);

  //US Permission
  const usEmployeeEdit =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_edit;
  const usEmployeeAdd =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_add;
  const usEmployeeDelete =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_delete;

  //MX Permission
  const mxEmployeeView = PERMISSIONS.permission_employee_mexicoemployee_view;
  const mxEmployeeEdit = PERMISSIONS.permission_employee_mexicoemployee_edit;
  const mxEmployeeAdd = PERMISSIONS.permission_employee_mexicoemployee_add;
  const mxEmployeeDelete =
    PERMISSIONS.permission_employee_mexicoemployee_delete;

  const hasUSAdd = userPermissions.includes(usEmployeeAdd);
  const hasUSEdit = userPermissions.includes(usEmployeeEdit);
  const hasUSDelete = userPermissions.includes(usEmployeeDelete);
  const usAdd = hasUSAdd && (user.isFranchise || user.isNonFranchise);
  const usEdit = hasUSEdit && (user.isFranchise || user.isNonFranchise);

  const hasMXAdd = userPermissions.includes(mxEmployeeAdd);
  const hasMXEdit = userPermissions.includes(mxEmployeeEdit);
  const hasMXDelete = userPermissions.includes(mxEmployeeDelete);

  const mexicoAdd = hasMXAdd && user.isMexico;
  const mexicoEdit = hasMXEdit && user.isMexico;

  const queryClient = useQueryClient();
  const [selectedRow, setSelectedRow] = useState(null);
  const [filter, setFilter] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [showFromNotification, setShowFromNotification] = useState(false);
  const [notifId, setNotiId] = useState("");
  const [filteredValue, setFiltervalue] = useRecoilState(empFilterValues);
  const [prevPage, setPrevPage] = useState(0);
  const [reportsToOptions, setReportsToOptions] = useState([]);
  const [isReportsToOpsLoading, setIsReportsToOpsLoading] = useState(false);
  const [isOnClose, setOnClose] = useState(false);
  const [isFromRecent, setIsFromRecent] = useRecoilState(FromNotifEmp);
  const { data: departmentData } = useEmployeeDepartment();
  const [fromOfficeView, setFromOfficeView] = useState(false);
  const [getOfficeId, setOfficeId] = useRecoilState(officeIdValue);
  const [orderBy, setOrderBy] = useState("");
  const setTableShow = useSetRecoilState(showTable);
  const setIsMexicoOnly = useSetRecoilState(mexicoOnly);
  const [showDataModal, setShowDataModal] = useRecoilState(showDataModalState);
  const newEmployeeData = useRecoilValue(employeeDataState);
  const [resetKey, setResetKey] = useState(0);

  const pageStateRef = useRef({
    page: 0,
    pageSize: 10,
  });

  const {
    fetchEmployees,
    refetchEmployees,
    employeesData,
    isEmployeesLoading,
    setIsEmployeesLoading,
    focus,
    setFocus,
  } = useEmployeesAsync(
    filteredValue,
    isOnClose,
    setOnClose,
    setSelectedRowsToDelete,
    setEmpList
  );

  useEffect(() => {
    fetchEmployees({ search: "" });
  }, []);

  useEffect(() => {
    fetchEmployees({ search: "" });
  }, [resetKey]);

  useEffect(() => {
    if (isOnClose && tableRef?.current && pageStateRef.current) {
      const { page, pageSize } = pageStateRef.current;

      tableRef.current.dataManager.changePageSize(pageSize);
      tableRef.current.onChangePage(null, page);

      setOnClose(false);
    }
  }, [isOnClose]);

  const sfEmpDepartmentOpt = departmentData
    ?.filter((x) => x.isActive)
    .map((x) => {
      return {
        value: x.employeeDepartmentId,
        label: x.employeeDepartmentName,
      };
    });
  const { mutateAsync: downloadEmployees, isLoading: isEmployeeDownloading } =
    useEmployeeAsyncDownload();
  const { data: agencies } = useSFGetOffice();
  const sfOfficeNameOpt = agencies
    ?.filter(
      (x) =>
        x.officeCode !== null &&
        x.officeCode !== undefined &&
        x.officeCode !== "" &&
        (user?.isFranchise
          ? x.officeType === "Franchise"
          : x.officeType !== "Franchise")
    )
    .map((x) => {
      return {
        id: x.officeCode,
        value: x.officeName,
        label: x.officeName,
      };
    });
  const { data: reportsToEmpOptions, isFetching: reportsToEmpOptionsLoading } =
    useGetReportsToEmployees();

  const { data: adOverrideGroup } = useGetEmployeeAdOverrideGroup();
  const overrideGroupOpts = adOverrideGroup
    ?.filter((x) => x.isActive)
    .map((x) => {
      return {
        value: x.adoverrideGroupId,
        label: x.adoverrideGroupName,
      };
    })
    ?.sort((a, b) => a.label.trim().localeCompare(b.label.trim()));

  let recordIdFromRecent = "";
  let location = useLocation();
  const history = useHistory();

  const searchClicked = () => {
    tableRef.current?.onChangePage(null, 0);
  };
  useEffect(() => {
    setSelectedRowsToDelete([]);
  }, [setSelectedRowsToDelete]);

  useEffect(() => {
    if (orderBy !== "") {
      setFiltervalue((prev) => ({
        ...prev,
        sort: orderBy,
      }));

      searchClicked();
    }
  }, [orderBy]);

  if (location.state != null) {
    recordIdFromRecent = location.state;
  }
  const handleLink = (rowDetails) => {
    const url = `/employeetab/employee`;
    history.push({
      pathname: `/employeetab/employee`,
      state: {
        employeenumber: rowDetails?.employeeId,
        action: "viewFromOffice",
        officeId: getOfficeId,
        rowDetails: rowDetails,
      },
    });
    window.location.reload();
    let userTabs = [];
    [...EmployeeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    window.location.reload();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  const saveTablePaginationState = () => {
    if (tableRef?.current?.dataManager) {
      pageStateRef.current = {
        page: tableRef.current.dataManager.currentPage,
        pageSize: tableRef.current.dataManager.pageSize,
      };
    }
  };

  const onClickFullName = (rowDetails) => {
    if (viewFromOffice) {
      localStorage.setItem("officeId", getOfficeId);

      setShowFromOffice(true);
      const url = "/employeetab/employee";
      history.push({
        pathname: `/employeetab/employee`,
        state: {
          employeenumber: rowDetails?.employeeId,
          action: "viewFromOffice",
          rowDetails: rowDetails,
          officeId: getOfficeId,
        },
      });
      let userTabs = [
        {
          to: "",
        },
      ];
      window.location.reload();
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0)
          userTabs.push({
            to: tabs.to,
          });
      });
      userTabs.shift();
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    } else {
      saveTablePaginationState();
      setShowState(true);
      setRowViewData({ ...rowDetails });
    }
  };

  const onClickCancelShow = () => {
    if (showFromOffice) {
      setShowFromOffice(false);
      //handleLink("officesetting");
    }
    if (showFromActiveReports) {
      const url = "/reportstab/employees/employees_activeemployees_reports";
      history.push({
        pathname: "/reportstab/employees/employees_activeemployees_reports",
        state: {
          employeeNumber: recordIdFromRecent.employeeNumber,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromActiveSPLCReports) {
      const url = "/reportstab/employees/employees_activesplcemployees_reports";
      history.push({
        pathname: "/reportstab/employees/employees_activesplcemployees_reports",
        state: {
          employeeNumber: recordIdFromRecent.employeeNumber,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      console.log({ recordIdFromRecent });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromNoEmailReports) {
      const url = "/reportstab/employees/employees_no_emailaddress_reports";
      history.push({
        pathname: "/reportstab/employees/employees_no_emailaddress_reports",
        state: {
          employeeNumber: recordIdFromRecent.employeeNumber,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromClosedLocation) {
      const url = "/reportstab/employees/employees_closedlocations_reports";
      history.push({
        pathname: "/reportstab/employees/employees_closedlocations_reports",
        state: {
          employeeNumber: recordIdFromRecent.employeeNumber,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromReportsWithTerminated) {
      const url =
        "/reportstab/employees/employees_withterminatedsupervisors_reports";
      history.push({
        pathname:
          "/reportstab/employees/employees_withterminatedsupervisors_reports",
        state: {
          employeeNumber: recordIdFromRecent.employeeNumber,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromReportsEmployeeActiveTempReports) {
      const url = "/reportstab/employees/employees_activetemp_reports";
      history.push({
        pathname: "/reportstab/employees/employees_activetemp_reports",
        state: {
          employeeNumber: recordIdFromRecent.employeeNumber,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromPendingTerminationReports) {
      const url = "/reportstab/employees/employees_pendingtermination_reports";
      history.push({
        pathname: "/reportstab/employees/employees_pendingtermination_reports",
        state: {
          employeeNumber: recordIdFromRecent.employeeNumber,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showOfficeHier) {
      const url = "/employeetab/employee";
      history.push({
        pathname: "/officesettings/officehierarchy",
        state: {
          officeHierarchyId: recordIdFromRecent.officeHierarchyId,
          action: "RedirectToOfficeHierarchy",
          prevPage: prevPage,
        },
      });

      window.location.reload();

      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowOfficeHierarchyFromView(true);
    }
    if (showFromHierarchy) {
      const url = "/employeetab/hierarchy";
      history.push({
        pathname: url,
        state: {
          hierarchyId: recordIdFromRecent.hierarchyId,
          action: "RedirectToHierarchy",
          prevPage: prevPage,
        },
      });

      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showFromHierarchyTable) {
      const url = "/employeetab/hierarchy";
      history.push({
        pathname: url,
        state: {
          action: "RedirectToHierarchyTable",
          prevPage: prevPage,
        },
      });

      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showFromHierarchyOrgChartNsa) {
      const url = "/employeetab/hierarchy";
      history.push({
        pathname: url,
        state: {
          action: "RedirectToHierarchyNsa",
        },
      });

      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showFromHierarchyOrgChartSplc) {
      const url = "/employeetab/hierarchy";
      history.push({
        pathname: "/employeetab/hierarchy/splc",
        state: {
          action: "RedirectToHierarchySplc",
        },
      });

      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showOfficeHierarchy) {
      const url = "/employeetab/employee";
      history.push({
        pathname: "/officesettings/officehierarchy",
        state: {
          action: "OfficeCancel",
          prevPage: prevPage,
        },
      });
      window.location.reload();
      const index = EmployeeTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setTableShow(true);
    }
    //For NSA Org Chart
    // if (showOfficeHierarchyNsaOrgChart) {

    //   const url = "/employeetab/employee";
    //   history.push({
    //     pathname: "/officesettings/officehierarchy/nsa",
    //     state: {
    //       action: "NsaOrgChartCancel",
    //     },
    //   });
    //   window.location.reload();
    //   const index = EmployeeTabs.findIndex((c) => c.to === url);
    //   setSelectedIndex(index);
    // }
    //For SPLC Org Chart
    if (showOfficeHierarchySplcOrgChart) {
      const url = "/employeetab/employee";
      history.push({
        pathname: "/officesettings/officehierarchy/splc",
        state: {
          action: "SplcOrgChartCancel",
        },
      });
      window.location.reload();
      const index = EmployeeTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    //For Sales Org Chart
    if (showOfficeHierarchySalesOrgChart) {
      const url = "/employeetab/employee";
      history.push({
        pathname: "/officesettings/officehierarchy",
        state: {
          action: "SalesOrgChartCancel",
        },
      });
      window.location.reload();
      const index = EmployeeTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showOfficeHierarchyFromView) {
      setShowOfficeHierarchyFromView(false);
      let ohIDFrom = new URLSearchParams(window.location.search).get(
        "officehierarchyid"
      );
      const url = "/carrieragreementmgmt/officehierarchy";
      history.push({
        pathname: `/carrieragreementmgmt/officehierarchy?actionFrom=Employee&officeHierarchyId=${ohIDFrom}`,
      });
      let userTabs = [];
      [...CarrierAgreementMgmtTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0)
          userTabs.push({
            to: tabs.to,
          });
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showProducerName) {
      const url = "/carrieragreementmgmt/producercodeconfig/table";
      history.push({
        pathname: "/carrieragreementmgmt/producercodeconfig/table",
        state: {
          moduleName: "Employee",
          masterCarrierId: fromProdCodeMcId,
          producerCodeId: producerCodeId,
          carrierKey: "CarrierAgreementMgmtKey",
        },
      });
      window.location.reload();
      const index = CarrierAgreementMgmtTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowState(false);
    }
    if (fromOfficeView) {
      const url = "/officesettings/officesetting";
      history.push({
        pathname: "/officesettings/officesetting",
        state: {
          action: "toOfficeView",
          officeId: getOfficeId,
        },
      });
      window.location.reload();
      const index = OfficeTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowState(false);
    }
    if (showFromEmpOrgChart) {
      history.push({
        pathname: "/employeetab/employee",
        state: {
          action: "CloseEmpOrgChart",
        },
      });
      window.location.reload();
    }
    setShowState(false);
    setOnClose(true);
    setRowViewData(null);

    //clear recordIdFromRecent
    history.replace({
      pathname: history.location.pathname,
      state: {},
    });

    localStorage.removeItem("empId");
    localStorage.removeItem("officeId");
    localStorage.removeItem("employeeRedirectState");
  };

  if (location.state !== null && location.state !== undefined) {
    recordIdFromRecent = location.state;
  }

  const {
    data: searchedData,
    isSuccess: searchSuccess,
    refetch: search,
  } = useSearchEmployees({ filteredValue });

  const [fromProdCodeMcId, setFromProdCodeMcId] = useState([]);
  const [producerCodeId] = useState("");
  const [toEmployeeData, setToEmployeeData] = useState([]);
  const { data: employeeData } = useEmployeeNumber(toEmployeeData);

  //Redirection from Producer Code
  const storedState = localStorage.getItem("employeeRedirectState");
  let redirectData = recordIdFromRecent;
  if (storedState) {
    redirectData = JSON.parse(storedState);
  }

  useEffect(() => {
    //Redirection from Reports
    let actionFrom = new URLSearchParams(window.location.search).get(
      "actionFrom"
    );
    let employeenumber = new URLSearchParams(window.location.search).get(
      "employeenumber"
    );

    if (actionFrom === "viewFromOffice") {
      setRowViewData(
        employees?.filter((x) => x.employeeId === Number(employeenumber))[0]
      );

      setShowState(true);
    }

    if (actionFrom === "OfficeHierarchy") {
      setRowViewData(
        employees?.filter((x) => x.employeeId === Number(employeenumber))[0]
      );
      setShowState(true);
      setShowOfficeHierarchy(true);
    }
    if (actionFrom === "OfficeHierarchyView") {
      setRowViewData(
        employees?.filter((x) => x.employeeId === Number(employeenumber))[0]
      );
      setShowState(true);
      setShowOfficeHierarchyFromView(true);
    }

    if (redirectData.action === "ProducerName") {
      setRowViewData(
        employees?.filter(
          (x) => x.employeeId === Number(redirectData.employeeNumber)
        )[0]
      );
      setFromProdCodeMcId(redirectData.masterCarrierId);
      setShowState(true);
      setShowProducerName(true);
    }

    if (actionFrom === "ProducerCodeRow") {
      const filteredData = employees?.filter(
        (x) => x.employeeId === Number(employeenumber)
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowProducerName(true);
    }

    if (isFromRecent && recordIdFromRecent.action === "closeFromRedirection") {
      setNotiId(Number(recordIdFromRecent?.recordId));
      setShowFromNotification(true);
      setIsFromRecent(false);
    }
    if (recordIdFromRecent?.action === "OfficeCancel") {
      const empId = {
        employeeId: Number(recordIdFromRecent?.employeeId),
      };
      setNotiId(Number(recordIdFromRecent?.recordId));
      setRowViewData(empId);
      setShowState(true);
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
    if (recordIdFromRecent.action === "OfficeHierarchy") {
      setRowViewData(
        employees
          ?.filter((x) => x.employeeId === recordIdFromRecent.recordId)
          ?.map((data) => ({ ...data }))[0]
      );
      setShowState(true);
      history.replace();
    }
    if (recordIdFromRecent && recordIdFromRecent.moduleName === "Employee") {
      setFiltervalue({
        isTressEmployee: userPermissions?.includes(mxEmployeeView),
        employeeId: recordIdFromRecent?.recordId?.split(".")?.join(","),
      });
      setNotiId(recordIdFromRecent?.recordId?.split(".")?.join(","));
      setShowFromNotification(true);
    } else {
      setFiltervalue({
        isTressEmployee: userPermissions?.includes(mxEmployeeView),
        employeeId: null,
      });
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [employees]);

  useEffect(() => {
    if (showFromNotification) {
      setFiltervalue({
        employeeId: notifId,
        isTressEmployee: userPermissions?.includes(mxEmployeeView),
      });
    }
  }, [showFromNotification]);

  useEffect(() => {
    if (!employeeData) return;

    const initEmployeeView = (employeeId) => {
      if (employeeId !== undefined) {
        setToEmployeeData(employeeId);
      }
      setRowViewData(employeeData);
      setShowState(true);
    };

    const empIdFromStorage = localStorage.getItem("empId");
    if (empIdFromStorage) {
      initEmployeeView(empIdFromStorage);
      setShowFromEmpOfficeDetails(false);
      return;
    }

    const actionHandlers = {
      RedirectToEmployee: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowOfficeHierarchy(true);
        setPrevPage(recordIdFromRecent.prevPage);
      },

      NsaOrgChart: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowOfficeHierarchyNsaOrgChart(true);
      },

      SplcOrgChart: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowOfficeHierarchySplcOrgChart(true);
      },

      SalesOrgChart: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowOfficeHierarchySalesOrgChart(true);
      },

      EmpOrgChart: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowFromEmpOrgChart(true);
        localStorage.setItem(
          "prevEmployeeId",
          recordIdFromRecent.prevEmployeeId
        );
      },

      viewFromOffice: () => {
        setRowViewData(recordIdFromRecent.rowDetails);
        setOfficeId(recordIdFromRecent.officeId);
        setShowState(true);
        setFromOfficeView(true);
      },

      CloseFromProducerCode: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
      },

      CloseEmpOrgChart: () => {
        const prevEmployeeId = localStorage.getItem("prevEmployeeId");
        initEmployeeView(prevEmployeeId ?? undefined);

        if (employeeData) {
          localStorage.removeItem("prevEmployeeId");
        }
      },

      FromHierarchyOrgChartSplc: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowFromHierarchyOrgChartSplc(true);
      },

      FromHierarchyOrgChartNsa: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowFromHierarchyOrgChartNsa(true);
      },
    };

    const reportHandlers = {
      ActiveEmployeeReports: () => setShowFromActiveReports(true),
      ActiveSPLCEmployeeReports: () => setShowFromActiveSPLCReports(true),
      NoEmailReports: () => setShowFromNoEmailReports(true),
      EmployeeClosedLocationReports: () => setshowFromClosedLocation(true),
      EmployeeWithTerminatedSupReports: () =>
        setShowFromReportsWithTerminated(true),
      EmployeeActiveTempReports: () =>
        setShowFromReportsEmployeeActiveTempReports(true),
      EmployeePendingTerminationReports: () =>
        setShowFromPendingTerminationReports(true),
    };

    const hierarchyHandlers = {
      ManagerRedirection: () => {
        initEmployeeView(recordIdFromRecent.idEmployee);
        setShowOfficeHier(true);
        setPrevPage(recordIdFromRecent.prevPage);
      },
      LeadershipRedirection: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setViewFromHierarchy(true);
      },
      FromHierarchyTable: () => {
        initEmployeeView(recordIdFromRecent.employeeId);
        setShowFromHierarchyTable(true);
      },
    };

    // Producer redirect
    if (redirectData.action === "Producer") {
      initEmployeeView(redirectData.employeeId);
      setFromProdCodeMcId(redirectData.masterCarrierId);
      setShowProducerName(true);
      return;
    }
    if (redirectData.action === "ProducerName") {
      initEmployeeView(Number(redirectData.employeeNumber));
      setFromProdCodeMcId(redirectData.masterCarrierId);
      setShowProducerName(true);
      setShowState(true);
      return;
    }

    // Action-based handlers
    actionHandlers[recordIdFromRecent.action]?.();

    // Reports
    if (reportHandlers[recordIdFromRecent.action]) {
      initEmployeeView(recordIdFromRecent.employeeNumber);
      reportHandlers[recordIdFromRecent.action]();
    }

    // Hierarchy
    hierarchyHandlers[recordIdFromRecent.actionToManager]?.();

    // Sales redirections
    if (recordIdFromRecent.actionToSalesPres === "SalesPresRedirection") {
      initEmployeeView(recordIdFromRecent.salesPresId);
      setShowOfficeHier(true);
    }

    if (recordIdFromRecent.actionToSalesVP === "SalesVPRedirection") {
      initEmployeeView(recordIdFromRecent.salesVPId);
      setShowOfficeHier(true);
    }
  }, [employeeData, viewFromOffice]);

  useEffect(() => {
    if (searchSuccess && searchedData) {
      history.replace();
      if (searchedData?.statusCode) {
        toast.fire("Server Error", "Cannot Get Employee Data", "error");
        setSearchedEmployee([]);
      } else {
        setIsSearching(true);
        setSearchedEmployee(searchedData);
      }
    }
  }, [searchSuccess, searchedData]);
  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.status)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRowsToDelete(forDelete);
  };
  if (deleteSuccess && deleteResult) {
    if (deleteResult.status === 200 || deleteResult.status === 201) {
      toast.fire(
        "Success",
        "Employees were deactivated successfully",
        "success"
      );
    } else {
      toast.fire(
        "Bulk deactivation of Employees failed",
        "Server Error: Cannot deactivate Employees",
        "error"
      );
    }
    queryClient.invalidateQueries(["GetAllEmployees"]);
    queryClient.invalidateQueries(["GetReportsToEmployeesOption"]);
    searchClicked();
    deleteReset();
  }

  if (deleteError && deleteResult) {
    searchClicked();
    toast.fire(
      "Bulk deactivation of Employees failed",
      "Server Error: Cannot deactivate Employees",
      "error"
    );
    queryClient.invalidateQueries(["GetReportsToEmployeesOption"]);
    queryClient.invalidateQueries(["GetAllEmployees"]);
    deleteReset();
  }

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRowsToDelete?.length
    } ${selectedRowsToDelete?.length > 1 ? "Employees" : "Employee"}?`}</div>
  );

  useEffect(() => {
    if (viewFromOffice) {
      if (officeCode) {
        setFiltervalue({
          location: officeCode,
        });
      }
    } else {
      setFiltervalue({
        isTressEmployee: userPermissions?.includes(mxEmployeeView),
        location: null,
      });
    }
  }, [viewFromOffice, officeCode]);

  //Form Options
  useEffect(() => {
    setReportsToOptions(
      reportsToEmpOptions?.map((x) => {
        return {
          id: x.employeeId,
          employeeNumber: x.employeenumber,
          value: x.employeeId,
          fullName: x.fullname,
          label: [
            x.fullname,
            x.employeenumber && x.employeenumber !== 0
              ? x.employeenumber
              : null,
            x.officeCode ? x.officeCode : null,
          ]
            .filter(Boolean) // Remove null/empty values
            .join(" - "),
          email: x.email,
          status: x.status,
          employeeType: x.employeeTypeName,
          termDate: x.terminationdate
            ? new Date(x.terminationdate).toISOString().split("T")[0]
            : "",
          isMexico: x.isMexico,
          employeeTitle: x.employeeTitleName,
          isSplc: x.isSplc,
        };
      })
    );

    setIsReportsToOpsLoading(reportsToEmpOptionsLoading);

    setEmployeesOption(
      reportsToEmpOptions?.map((x) => {
        return {
          id: x.employeeId,
          employeeNumber: x.employeenumber,
          value: x.fullname,
          label: [
            x.fullname,
            x.employeenumber && x.employeenumber !== 0
              ? x.employeenumber
              : null,
            x.officecode ? x.officecode : null,
          ]
            .filter(Boolean) // Remove empty values
            .join(" - "),
          email: x.email,
          status: x.status,
          employeeType: x.employeeTypeName,
          termDate: x.terminationdate
            ? new Date(x.terminationdate).toISOString().split("T")[0]
            : "",
          isMexico: x.isMexico,
        };
      })
    );
  }, [
    reportsToEmpOptions,
    reportsToEmpOptionsLoading,
    employees,
    setEmployeesOption,
  ]);

  const handleDelete = () => {
    const ids = selectedRowsToDelete.map((row) => row.employeeId);
    deleteEmployeesByNumber(ids);
    setSelectedRowsToDelete([]);
    setOpenModalDelete(false);
    searchClicked();
  };

  // Filter data for edit
  const [editEmployeeId, setEditEmployeeId] = useState(null);
  const { data: editEmployeeData } = useEmployeeNumber(editEmployeeId);

  useEffect(() => {
    if (!editEmployeeData || !editEmployeeId) return;
    processHandleEdit(editEmployeeData);
    setEditEmployeeId(null);
  }, [editEmployeeData, editEmployeeId]);

  const handleEdit = (rowDetails) => {
    if (viewFromOffice) {
      setShowFromOffice(true);
      handleLink(rowDetails);
      setShowState(false);
      setAddState(false);
      return;
    }
    setIsEmployeesLoading(true);
    queryClient.removeQueries({
      queryKey: ["GetEmployeesByEmployeeNumber", rowDetails.employeeId],
    });
    setEditEmployeeId(rowDetails.employeeId);
  };

  const formatDate = (date) =>
    date ? new Date(date).toISOString().split("T")[0] : undefined;

  const isValidField = (value) =>
    value !== "" && value !== " " && value !== null;

  const buildShippingLocation = (employeeData) => {
    const { address, city, employeeState, zipcode, street, country } =
      employeeData;

    const part1 = isValidField(address) ? address + ", " : "";
    const part2 = isValidField(city) ? city + ", " : "";
    const part3 = isValidField(employeeState) ? employeeState + " " : "";
    const part4 = isValidField(zipcode) ? zipcode + ", " : "";
    const hasLocation = street || city || employeeState || zipcode;
    const part5 = hasLocation ? country || "" : "";

    return part1 + part2 + part3 + part4 + part5;
  };

  const getOfficeCode = (employeeData, sfOfficeNameOpt) => {
    if (!employeeData.officecode) return employeeData.officecode;

    const isFranchise =
      employeeData.employeeTypeName?.toLowerCase() === "franchise";
    if (!isFranchise) return employeeData.officecode;

    const officeCodeValues = employeeData.officecode.split(",");
    const filteredOfficeCode = officeCodeValues.map((x) =>
      sfOfficeNameOpt?.filter((c) => c?.id === x)
    );
    return filteredOfficeCode.map((x) => x?.map((c) => c)[0]);
  };

  const processHandleEdit = (employeeData) => {
    const empStatus = employees?.filter(
      (x) => x.EmployeeId === employeeData.reportsToEmployeeId
    );

    const adOverrideGroupValue = employeeData?.adOverrideGroup
      ?.split(",")
      ?.map((id) => overrideGroupOpts?.find((o) => o.value === Number(id)))
      ?.filter(Boolean);

    const reportstotermdate =
      empStatus?.length > 0
        ? formatDate(empStatus[0]?.terminationdate)
        : formatDate(employeeData?.reportstotermdate);

    setRowToEdit({
      ...employeeData,
      reportsToEmployeeId: employeeData.reportsToEmployeeId,
      officecode: getOfficeCode(employeeData, sfOfficeNameOpt),
      adOverrideGroup: adOverrideGroupValue || [],
      hiredate: formatDate(employeeData?.hiredate),
      startdate: formatDate(employeeData?.startdate),
      terminationdate: formatDate(employeeData?.terminationdate),
      rehireDate: formatDate(employeeData?.rehireDate),
      changeeffectivedate: formatDate(employeeData?.changeeffectivedate),
      onLeaveEffectiveDate: formatDate(employeeData?.onLeaveEffectiveDate),
      leavereturndate: formatDate(employeeData?.leavereturndate),
      reportstostatus: empStatus ? empStatus[0]?.status : employeeData.status,
      reportstotermdate,
      shippingLocation: buildShippingLocation(employeeData),
      address: employeeData.address,
      city: employeeData.city,
      stateCode: employeeData.stateCode,
      state: employeeData.employeeState,
      postalCode: employeeData.postalCode,
      zipcode: employeeData.zipcode,
      country: employeeData.country,
      countryCode: employeeData.countryCode,
      latitude: employeeData.latitude,
      longitude: employeeData.longitude,
      geolocation: employeeData.geolocation,
      county: employeeData.county,
    });

    setEditstate(true);
    setIsEmployeesLoading(false);
  };

  const mapExportData = async () => {
    try {
      const blobResponse = await downloadEmployees(filteredValue);

      const blob = new Blob([blobResponse]);
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;

      const dateTimeToday = new Date().toISOString();
      link.setAttribute(
        "download",
        `EmployeeModuleReport_${dateTimeToday}.csv`
      );

      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(downloadUrl);

      toast.fire(
        "Download Employee",
        "Employee downloaded successfully.",
        "success"
      );
    } catch {
      toast.fire(
        "Download Employee",
        "Server Error: Cannot download Employee.",
        "error"
      );
    }
  };

  const { data: titleData } = useEmployeeTitle();

  const sfEmpTitleOpt = titleData?.data
    .filter((x) => x.isActive)
    .map((x) => {
      return {
        value: x.employeeTitleId,
        label: x.employeeTitleName,
      };
    });

  const handleMultiOffice = (rowDetails) => {
    const codes = rowDetails.officecode?.split(",");
    if (
      rowDetails.employeeTypeName?.toLowerCase() === "franchise" &&
      codes?.length > 1
    ) {
      const url = "/officesettings/officesetting";
      history.push({
        pathname: `/officesettings/officesetting`,
        state: {
          action: "employeeMultipleOffice",
          officeCodes: rowDetails.officecode,
        },
      });
      window.location.reload();
      setOfficeCodeList(rowDetails.officecode);
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    } else {
      const url = "/officesettings/officesetting";

      history.push({
        pathname: url,
        state: {
          officeCode: rowDetails.officecode,
          action: "EmployeeTable",
          employeeId: rowDetails.employeeId,
          fromRedirection: showFromNotification ? "Yes" : "No",
          empId: notifId,
        },
      });
      window.location.reload();
      let userTabs = [
        {
          to: "",
        },
      ];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0)
          userTabs.push({
            to: tabs.to,
          });
      });
      userTabs.shift();
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
  };

  //searchbox focus
  useEffect(() => {
    const handleClickOutside = (e) => {
      const searchBox = document.querySelector("input[placeholder='Search']");
      if (searchBox && !searchBox.contains(e.target)) {
        setFocus(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const isMexicoOnly =
      user.isMexico === true &&
      user.isFranchise === false &&
      user.isNonFranchise === false;

    setIsMexicoOnly(isMexicoOnly);
  }, [user, setIsMexicoOnly]);

  const ActionDisable = (rowDetails) => {
    const isMexico = rowDetails.isMexico;
    const isFranchiseType = rowDetails.employeeTypeName
      ?.toLowerCase()
      ?.includes("franchise");

    const isConfieOnly = user.isNonFranchise && !user.isFranchise;
    const isFranchiseOnly = !user.isNonFranchise && user.isFranchise;

    if (!isMexico) {
      if (usEdit) {
        if (isConfieOnly && isFranchiseType) return true;
        if (isFranchiseOnly && !isFranchiseType) return true;
        return false;
      }
      return true;
    }

    if (isMexico) {
      if (mexicoEdit) return false;
      return true;
    }
    return false;
  };

  const HyperlinkDisable = (rowDetails) => {
    const isFranchiseType = rowDetails.employeeTypeName
      ?.toLowerCase()
      ?.includes("franchise");

    if (user.isMexico) {
      if (user.isFranchise && user.isNonFranchise) {
        return false;
      }

      return (
        rowDetails?.isMexico !== true &&
        (user.isFranchise
          ? !isFranchiseType
          : user.isNonFranchise
          ? isFranchiseType
          : true)
      );
    } else {
      if (rowDetails?.isMexico === true) {
        return true;
      }
    }

    return (
      (user.isNonFranchise && !user.isFranchise && isFranchiseType) ||
      (!user.isNonFranchise && user.isFranchise && !isFranchiseType)
    );
  };

  const toTitleCase = (value) =>
    value?.toLowerCase().replaceAll(/\b\w/g, (char) => char.toUpperCase()) ??
    "";

  const matColumns = [
    {
      title: "Id",
      field: "employeenumber",
      render: (rowDetails) => {
        return (
          <div>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-purple-100 text-violet-800">
              {rowDetails.employeenumber}
            </span>
          </div>
        );
      },
    },
    {
      title: "Full Name",
      field: "fullname",
      width: "25%",
      render: (rowDetails) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              onClickFullName(rowDetails);
            }}
          >
            <span className="blueAndBold underline ">
              {toTitleCase(rowDetails.fullname)}
            </span>
          </div>
        );
      },
    },

    { title: "Employee Type", field: "employeeTypeName" },
    { title: "Business Operation", field: "businessOperation" },
    {
      title: "Title",
      field: "employeeTitleName",
    },
    {
      title: "Reports To",
      field: "reportsToEmployeeName",
      searchable: false,
      render: (rowDetails) => toTitleCase(rowDetails.reportsToEmployeeName),
    },

    {
      title: "Country",
      field: "isMexico",
      render: (rowData) => (rowData.isMexico ? "Mexico" : "United States"),
    },

    user?.isFranchise
      ? {
          title: "Office Codes",
          field: "officecode",
          render: (rowDetails) => {
            return HyperlinkDisable(rowDetails) ? (
              <>
                {rowDetails.officecode +
                  (rowDetails.officeName ? " - " + rowDetails.officeName : "")}
              </>
            ) : (
              <div
                className="cursor-pointer"
                onClick={() => {
                  handleMultiOffice(rowDetails);
                }}
              >
                {" "}
                {rowDetails.employeeTypeName === "Franchise" &&
                rowDetails.officecode?.split(",")?.length > 1 ? (
                  rowDetails.officecode.length > 12 ? (
                    <span
                      data-tip={rowDetails.officecode}
                      className="blueAndBold underline"
                    >
                      <Tooltip
                        place="top"
                        effect="solid"
                        type="info"
                        border={true}
                        arrowColor="#0078d7"
                        borderColor="#0078d7"
                        backgroundColor="white"
                        textColor="#0078d7"
                      />
                      {rowDetails.officecode.substring(0, 12).trim() + "..."}
                    </span>
                  ) : (
                    <span className="blueAndBold underline">
                      {rowDetails.officecode}
                    </span>
                  )
                ) : (
                  rowDetails.officecode && (
                    <span className="blueAndBold underline">
                      {rowDetails.officecode +
                        (rowDetails.officeName
                          ? " - " + rowDetails.officeName
                          : "")}
                    </span>
                  )
                )}
              </div>
            );
          },
        }
      : {
          title: "Office Location",
          field: "officecode",
          render: (rowDetails) => {
            return HyperlinkDisable(rowDetails) ? (
              <>
                {rowDetails.officecode +
                  (rowDetails.officeName ? " - " + rowDetails.officeName : "")}
              </>
            ) : (
              <div
                className="cursor-pointer"
                onClick={() => {
                  handleMultiOffice(rowDetails);
                }}
              >
                <span className=" blueAndBold underline">
                  {rowDetails.officecode +
                    (rowDetails.officeName
                      ? " - " + rowDetails.officeName
                      : "")}
                </span>
              </div>
            );
          },
        },

    { title: "Status", field: "status" },
    {
      title: "Action",
      sorting: false,
      name: "Action/s",
      align: "center",
      render: (rowDetails) => {
        if (!(usEdit || mexicoEdit)) {
          return null;
        }

        return (
          <div className="flex place-content-center mr-5">
            <EditButton
              className=""
              buttonText="Edit"
              onClick={() => {
                saveTablePaginationState();
                handleEdit(rowDetails);
                if (viewFromOffice) {
                  localStorage.setItem("isEditFromOffice", true);
                }
              }}
              disabled={ActionDisable(rowDetails)}
            />
          </div>
        );
      },
    },
  ];

  const handleSortingChange = (orderBy, orderDirection) => {
    const orderByField = matColumns[orderBy]?.field;
    if (orderByField !== undefined) {
      setOrderBy(orderByField + " " + orderDirection);
    } else {
      setOrderBy(null);
    }
  };

  if (viewFromOffice) {
    setAddState(false);
    setEditstate(false);
    setRowToEdit();
    setShowState(false);
  }

  //Handle Permissions
  const addPermission =
    ((user.isFranchise || user.isNonFranchise) &&
      userPermissions.includes(usEmployeeAdd)) ||
    (user.isMexico && userPermissions.includes(mxEmployeeAdd));

  const employeeTableOrView = isShow ? (
    rowViewData && (
      <EmployeesExpandedRow
        titleOption={sfEmpTitleOpt}
        DepOption={sfEmpDepartmentOpt}
        rowData={rowViewData}
        rowIsExpanded={true}
        handleEdit={handleEdit}
        onClickCancelShow={onClickCancelShow}
        actionDisable={ActionDisable}
        hyperlinkDisable={HyperlinkDisable}
        hasUSAdd={usAdd}
        hasUSEdit={usEdit}
        mexicoAdd={mexicoAdd}
        mexicoEdit={mexicoEdit}
      />
    )
  ) : (
    <div className={viewFromOffice ? "p-2 min-h-fit" : "px-8 py-4 min-h-fit"}>
      {!viewFromOffice ? (
        <div className="flex justify-between items-center">
          <div>
            <div className="flex gap-2 items-center">
              <div>
                <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">Employees</h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  All Employees
                </h1>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div className="flex justify-between pt-2">
        <div>
          {!viewFromOffice ? (
            <button
              className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                  gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
              onClick={() => {
                setFilter(!filter);
                setFiltervalue([]);
              }}
            >
              <div>Filter By</div>
              <FunnelIcon className="h-3 w-3 focus:bg-primary" />
            </button>
          ) : null}
        </div>
        <div className="flex justify-between gap-2">
          {(addPermission && !viewFromOffice) ||
          (!officeCode && viewFromOffice && addPermission) ? (
            <AddButton
              buttonText="Add"
              onClick={() => {
                saveTablePaginationState();
                setAddState(!isAdd);
              }}
            />
          ) : null}
          {!viewFromOffice ? (
            <>
              {" "}
              <DownloadButton
                buttonValue={
                  isEmployeeDownloading ? "Downloading..." : "Download File"
                }
                onClick={() => {
                  mapExportData();
                }}
                disabled={isEmployeeDownloading}
              />
            </>
          ) : null}
        </div>
      </div>
      <main className="flex">
        {filter && (
          <div className="w-1/4 bg-white">
            <TableFilters
              searchRefetch={search}
              setSearchedEmployee={setSearchedEmployee}
              setIsSearching={setIsSearching}
              setReset={setReset}
              isSearching={isSearching}
              EmployeesAsyncData={fetchEmployees}
              empList={empList}
              searchClicked={searchClicked}
              setResetKey={setResetKey}
            />
          </div>
        )}
        <div
          className={`w-full ${
            filter ? "h-5/6 bg-white p-1 overflow-x-auto" : "w-full"
          }`}
        >
          {(hasUSDelete || hasMXDelete) && (
            <div className="text-secondary py-2 italic text-xs3">
              <div>
                <p className="self-center font-bold italic inline-block mr-1">
                  Note:{" "}
                </p>
                Tick the box to deactivate some data.
              </div>
            </div>
          )}
          <div
            className={`w-full bg-white box-shadow overflow-x-auto ${
              isEmployeesLoading ? "mb-4" : ""
            }`}
          >
            <div className="grid grid-row">
              <MaterialTableEmployees
                isHideEmpPagerow={isHideEmpPagerow}
                data={employeesData}
                isLoading={isEmployeesLoading}
                exportButton={false}
                tableRef={tableRef}
                onSearchChange={(value) => {
                  if (selectedRow !== null) setSelectedRow(null);
                  setFocus(true);
                  setFiltervalue((prev) => ({
                    ...prev,
                    search: value || "",
                  }));
                }}
                setOpenModal={setOpenModalDelete}
                toolbar={true}
                toolbarButtonAlignment={"left"}
                showTitle={false}
                search={true}
                columns={matColumns}
                searchFieldAlignment="left"
                selectedRow={selectedRow}
                selection={
                  userPermissions.includes(usEmployeeDelete) ||
                  userPermissions.includes(mxEmployeeDelete)
                }
                onSelectionChange={handleSelectedRowsChange}
                isDeactivate={true}
                selectedRows={selectedRowsToDelete}
                isActive={false}
                searchAutoFocus={focus}
                options={{
                  showTitle: false,
                }}
                onOrderChange={(orderBy, orderDirection) => {
                  handleSortingChange(orderBy, orderDirection);
                }}
              />
              <ConfirmBoxDelete
                ModalTitle="Deactivate Employee Information"
                qConfirmation={deleteMessage}
                isOpen={openModalDelete}
                onClose={() => setOpenModalDelete(false)}
                onClickFunction={handleDelete}
              />

              <ConfirmBoxOk
                isOpen={showDataModal}
                onClose={() => setShowDataModal(false)}
                ModalTitle="New Employee Record was added"
                qConfirmation={
                  <>
                    <p>
                      Record ID: <strong>{newEmployeeData.recordId}</strong>
                    </p>
                    <p>
                      Full Name: <strong>{newEmployeeData.fullName}</strong>
                    </p>
                  </>
                }
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );

  return (
    <>
      {isAdd || isEdit ? (
        <div className="px-8 py-4 min-h-fit">
          <EmployeeForm
            reportsToOptions={reportsToOptions}
            employeesOpts={employeesOption}
            isReportsToOpsLoading={isReportsToOpsLoading}
            overrideGroupOpts={overrideGroupOpts}
            setOnClose={setOnClose}
            onClickCancelShow={onClickCancelShow}
            hasUSAdd={usAdd}
            mexicoAdd={mexicoAdd}
            onSaveSuccess={refetchEmployees}
          />
        </div>
      ) : (
        employeeTableOrView
      )}
    </>
  );
};

export default EmployeesTable;
